import type { AppRouteRecordRaw } from '@/router/types'
import { systemManageRoutes } from './systemManageRoutes'
import { systemLogRoutes } from './systemLog'
import { marketingSystemRoutes } from './marketingSystemRoutes'
import { customerManageConfigRoutes } from '@/router/customManageConfig'
import { followRecordRoutes } from '@/router/followRecord'
import { recycleBinRoutes } from '@/router/recycleBin'
import { settingCenter } from '@/router/settingCenter'
import { financial } from './financial'
import { flowMonitoringManage } from './flowMonitoringManage'
import { faceSignManage } from './faceSignManage'
import { dataCenterRoutes } from './dataCenter'
import { CustomEnum } from '@/router/types'
import { callCenterRoutes } from '@/router/callCenter'
import { manualOrderRoutes } from '@/router/manualOrderRoutes'
import { callCenterConfigRoutes } from '@/router/callCenterConfig'
import { clueManageRoutes } from '@/router/clueManage'
import { clueRecycleManageRoutes } from '@/router/clueRecycleManage'
import { clueHighSeasManageRoutes } from '@/router/clueHighSeasManage'
import { workbenchConfiguration } from '@/router/workbenchConfiguration'
import { loanManagementConfiguration } from '@/router/loanManagementConfiguration'
import { markingOrderRoutes } from './markingOrder'
import { appStoreRoutes } from './appStore'
import { erpRoutes } from './erpRoutes'
import { systemSafeMangeRoutes } from './systemSafeMange'
import { agreementSignHistory } from './agreementSignHistory'
import { zzyRoutes } from './zzy'
import { cpsRoutes } from './cpsRoutes'
import { rytRoutes } from './rytRoutes'
import { cpsFinancial } from './cpsFinancial'
export const rootRoute: AppRouteRecordRaw[] = [
  {
    path: '/',
    name: 'Layout',
    redirect: '/workbench',
    component: () => import('@/views/layout/index.vue'),
    meta: {
      title: '布局',
      isLogin: true
    },
    children: [
      {
        path: '/:pathMatch(.*)',
        component: () => import('@/views/404/index.vue'),
        meta: {
          title: '404',
          isLogin: false
        }
      },
      {
        path: '/403',
        component: () => import('@/views/403/index.vue'),
        meta: {
          title: '403',
          isLogin: false
        }
      },
      {
        path: 'workbench',
        name: 'Workbench',
        component: () => import('@/views/workbench/index.vue'),
        meta: {
          title: '工作台',
          keepAlive: true
        }
      },
      {
        path: 'todoManage',
        name: 'TodoManage',
        component: () => import('@/views/workbench/components/todoList/index.vue'),
        meta: {
          title: '待办事项',
          keepAlive: true
        }
      },
      {
        path: '/502',
        component: () => import('@/views/502/index.vue'),
        meta: {
          title: '502',
          isLogin: false
        }
      },
      {
        path: 'customerManage/:menuId?',
        name: 'CustomerManage',
        component: () => import('@/views/customerManage/index.vue'),
        meta: {
          title: '客户管理',
          keepAlive: true
        }
      },
      {
        path: 'customerDetail',
        name: 'CustomerDetail',
        component: () => import('@/views/customerManage/customerDetail/index.vue'),
        meta: { title: '客户详情' }
      },
      {
        path: 'highSeaManage/:menuId?',
        name: 'HighSeaManage',
        component: () => import('@/views/highSeaManage/index.vue'),
        meta: {
          title: '公海管理',
          keepAlive: true
        }
      },
      {
        path: 'highSeaDetail',
        name: 'HighSeaDetail',
        component: () => import('@/views/highSeaManage/customerDetail/index.vue'),
        meta: { title: '公海详情' }
      },
      {
        path: 'customPage/:menuId/:id',
        name: 'CustomPage',
        component: () => import('@/views/customPage/index.vue'),
        meta: {
          title: CustomEnum.Name,
          keepAlive: true
        }
      },
      {
        path: 'customDetailPage',
        name: 'CustomDetailPage',
        component: () => import('@/views/detailPage/customDetailPage/index.vue'),
        meta: {
          title: '自定义应用详情'
        }
      },
      {
        path: 'accountConfig',
        name: 'accountConfig',
        component: () => import('@/views/accountConfig/index.vue'),
        meta: {
          title: '资料设置'
        }
      },
      {
        path: 'personInfo',
        name: 'PersonInfo',
        component: () => import('@/views/accountConfig/PersonInfo.vue'),
        meta: {
          title: '个人中心'
        }
      },
      {
        path: 'inquiryManageDetail',
        name: 'inquiryManageDetail',
        component: () => import('@/views/markingOrder/inquiryManage/inquiryDetail/index.vue'),
        meta: {
          title: '询单详情'
        }
      },
      ...systemManageRoutes,
      ...customerManageConfigRoutes,
      ...marketingSystemRoutes,
      ...settingCenter,
      ...followRecordRoutes,
      ...recycleBinRoutes,
      ...flowMonitoringManage,
      ...faceSignManage,
      ...financial,
      ...callCenterRoutes,
      ...callCenterConfigRoutes,
      ...dataCenterRoutes,
      ...systemLogRoutes,
      ...markingOrderRoutes,
      ...clueManageRoutes,
      ...clueRecycleManageRoutes,
      ...clueHighSeasManageRoutes,
      ...appStoreRoutes,
      ...workbenchConfiguration,
      ...loanManagementConfiguration,
      ...erpRoutes,
      ...systemSafeMangeRoutes,
      ...agreementSignHistory,
      ...zzyRoutes,
      ...cpsRoutes,
      ...rytRoutes,
      ...cpsFinancial,
      ...manualOrderRoutes
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
      isLogin: false
    }
  },
  {
    path: '/h5Download',
    name: 'h5Download',
    component: () => import('@/views/h5Download/index.vue'),
    meta: {
      title: '下载',
      isLogin: false
    }
  },
  {
    path: '/iosDownload',
    name: 'iosDownload',
    component: () => import('@/views/h5Download/iosDownload.vue'),
    meta: {
      title: '下载',
      isLogin: false
    }
  },
  {
    path: '/receiptDownloadLink',
    name: 'ReceiptDownloadLink',
    component: () =>
      import('@/views/erp/systemManage/financeManage/accountManage/components/h5Link/index.vue'),
    meta: {
      title: '回单下载',
      isLogin: false
    }
  }
]

/**
 * 需要配置菜单的路由
 */
export const authMenuRoute: AppRouteRecordRaw[] = [...systemManageRoutes]
